import { executionArtifactLineId } from '../families/execution-artifact.js';
import { memorySegmentId } from '../families/memory-layout.js';
import type { AnnotationLayerSpec } from '../model.js';

/** A warm teacher pass over the otherwise exact orthographic memory view. */
export function memoryTeachingAnnotations(): AnnotationLayerSpec {
  return {
    id: 'memory-teacher-pass',
    seed: 104729,
    marks: [
      {
        id: 'circle-padding',
        kind: 'circle',
        targetSemanticId: memorySegmentId('alignment-gap'),
      },
      {
        id: 'underline-balance',
        kind: 'underline',
        targetSemanticId: memorySegmentId('balance'),
      },
      {
        id: 'flow-to-balance',
        kind: 'arrow',
        fromAnchorId: `${memorySegmentId('account-id')}.end`,
        toAnchorId: `${memorySegmentId('balance')}.start`,
      },
      {
        id: 'padding-note',
        kind: 'note',
        targetSemanticId: memorySegmentId('alignment-gap'),
        text: 'Allocated, but not yours',
      },
      {
        id: 'field-brace',
        kind: 'brace',
        targetSemanticId: memorySegmentId('account-id'),
      },
    ],
  };
}

/** Teacher marks laid over verbatim evidence without altering terminal text. */
export function executionEvidenceAnnotations(): AnnotationLayerSpec {
  return {
    id: 'execution-evidence-pass',
    seed: 130363,
    marks: [
      {
        id: 'circle-runtime',
        kind: 'circle',
        targetSemanticId: executionArtifactLineId('execution-time'),
      },
      {
        id: 'underline-filter-cost',
        kind: 'underline',
        targetSemanticId: executionArtifactLineId('rows-removed'),
      },
      {
        id: 'connect-cost-to-runtime',
        kind: 'arrow',
        fromAnchorId: `${executionArtifactLineId('rows-removed')}.baseline`,
        toAnchorId: `${executionArtifactLineId('execution-time')}.baseline`,
      },
      {
        id: 'evidence-note',
        kind: 'note',
        targetSemanticId: executionArtifactLineId('execution-time'),
        text: 'This is measured, not estimated',
      },
      {
        id: 'runtime-brace',
        kind: 'brace',
        targetSemanticId: executionArtifactLineId('execution-time'),
      },
    ],
  };
}
